import { Box, Text } from '@chakra-ui/react';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Accordion } from '@morressier/alembic';
import { IUADReportWithDetails } from '@publishing-engine/domain/models';
import ReportEntriesList from './ReportEntriesList';
import { formatDateAndTime } from 'src/utils/date';
interface Props {
  acknowledgedComments: IUADReportWithDetails[];
}
const AcknowledgeComments = ({ acknowledgedComments }: Props) => {
  return (
    <>
      <Box mt={2}>
        <Accordion
          chakraAccordionProps={{
            allowMultiple: true,
            width: '100%',
            defaultIndex: [0]
          }}
          accordionItemProps={{
            border: '2px',
            borderColor: 'surfaceSecondaryFill'
          }}
          items={acknowledgedComments.map(details => {
            const GeneratedDate = details?.date
              ? formatDateAndTime(details.date)
              : '--';
            const AcknowledgedDate = details?.acknowledgedOn
              ? formatDateAndTime(details.acknowledgedOn)
              : '--';
            return {
              title: (
                <Box py={0.5}>
                  <Text textStyle={'headingItem'} as={'span'}>
                    {details?.name}
                  </Text>{' '}
                  <Text as={'span'} textStyle={'textBody'}>
                    ({details?.uadEntries?.length} activities)
                  </Text>
                  <Text textStyle={'textContext'}>
                    Generated on {GeneratedDate}
                  </Text>
                </Box>
              ),
              badge: (
                <>
                  <FontAwesomeIcon color="green" icon={faCircleCheck} />
                </>
              ),
              content: (
                <>
                  <Box mx={-4} my={2}>
                    <Box
                      borderWidth="1px"
                      borderRadius="md"
                      p={3}
                      backgroundColor={'white'}
                      mx={3}
                    >
                      <Text
                        textStyle={'headingOverline'}
                        fontWeight={'semibold'}
                      >
                        Acknowledged on {AcknowledgedDate} by{' '}
                        {details?.acknowledgedBy?.firstName}{' '}
                        {details?.acknowledgedBy?.lastName}
                      </Text>
                      <Box fontSize={'sm'}>
                        <Box as="span">Comment :</Box> {details.comment}
                      </Box>
                    </Box>
                    <ReportEntriesList entries={details?.uadEntries} />
                  </Box>
                </>
              )
            };
          })}
        />
      </Box>
    </>
  );
};
export default AcknowledgeComments;
